import React from 'react'
import DropDown from 'wix-base-ui/lib/controls/dropDown'
import MaskedItem from './maskedItem.jsx'
import _ from 'lodashParts'

class FixedButtonContextMenu extends React.Component {
    render() {
        return (
            <DropDown
                automationId={this.props.automationId}
                hasArrowIcon={false}
                className="richtext-dropdown richtext-context-dropdown toolbar-mode"
                optionsContainerClassName="richtext-dropdown-options richtext-context-dropdown-options"
                onChange={this.props.onChange}
                value={this.props.value}>
                {
                    _.map(this.props.options, opt => <MaskedItem key={opt.value} value={opt.value} maskSymbol={this.props.buttonSymbol || opt.maskSymbol} symbol={opt.symbol} onClick={opt.action}>{opt.label}</MaskedItem>)
                }
            </DropDown>
        )
    }
}

FixedButtonContextMenu.defaultProps = {
    options: [],
    onChange: _.noop
}

FixedButtonContextMenu.propTypes = {
    value: React.PropTypes.oneOfType([
        React.PropTypes.string,
        React.PropTypes.number
    ]),
    buttonSymbol: React.PropTypes.string,
    options: React.PropTypes.array.isRequired,
    disabled: React.PropTypes.bool,
    onChange: React.PropTypes.func
}

module.exports = FixedButtonContextMenu



// WEBPACK FOOTER //
// ./src/components/toolbar/fixedButtonContextMenu.jsx